export default "__VITE_ASSET__CHbUuzyT__"